import { ChangeEmitter } from '@/application/ChangeEmitter';
import { TextboxField } from '@/domain/textbox/TextboxField';
import type { I2DEngine } from '@/application/ports/I2DEngine';
import type { IEntityRepository } from '@/application/ports/IEntityRepository';
import type { TSelectionRange } from '@/domain/textbox/TSelectionRange';
import type { TTextLayoutPatch } from '@/domain/textbox/TTextLayoutPatch';
import type { TTextStylePatch } from '@/domain/textbox/TTextStylePatch';

class TextController {
    constructor(
        private readonly _engine: I2DEngine,
        private readonly _repository: IEntityRepository,
        private readonly _changeEmitter: ChangeEmitter,
    ) {}

    applyTextStyle(entityId: string, patch: TTextStylePatch, range?: TSelectionRange): void {
        const entity = this._repository.get(entityId);
        if (!(entity instanceof TextboxField)) {
            return;
        }
        const result = this._engine.applyTextStyle(entityId, patch, range);
        if (!result) {
            return;
        }
        entity.applyStyle(patch, result, range);
        this._repository.update(entity);
        this._changeEmitter.emit();
    }

    applyTextLayout(entityId: string, patch: TTextLayoutPatch): void {
        const entity = this._repository.get(entityId);
        if (!(entity instanceof TextboxField)) {
            return;
        }
        const result = this._engine.applyTextLayout(entityId, patch);
        if (!result) {
            return;
        }
        entity.applyLayout(patch, result);
        this._repository.update(entity);
        this._changeEmitter.emit();
    }
}

export { TextController };
